<template>
  <div class="m-base-swiper">
    <div class="swiper-box swiper-container" ref="swiperBox">
      <div class="swiper-content swiper-wrapper">
        <div class="swiper-item swiper-slide app-flex-mid-center" v-for="item in list" :key="item.id">
          <div class="show-image app-flex-mid-center">
            <img :src="item.url" class="banner-all-image" />
            <div class="text-wrap">
              <m-base-text :title="item.rich" color="#fff" shadow-color="rgba(255,255,255, 0.3)" type="large"></m-base-text>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-point" slot="pagination"></div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import MBaseText from '../components/MBaseText.vue'

export default {
  name: 'MBaseSwiper',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    MBaseText
  },
  data() {
    return {}
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    // 初始化 swiper
    initSwiper() {
      const bannerSwiper = new Swiper(this.$refs.swiperBox, {
        autoplay: true, //可选选项，自动滑动
        initialSlide: 0, // 设定初始化时slide的索引
        setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高
        loop: true, // 循环
        speed: 1000, // 切换速度，即slider自动滑动开始到结束的时间（单位ms）
        delay: 4000,
        pagination: {
          el: '.custom-point',
          clickable: true,
          type: 'bullets',
          bulletClass: 'my-bullet', //需设置.my-bullet样式
          bulletActiveClass: 'my-bullet-active' // 定义pagination 分页器内当前活动块的指示小点的类名。
        }
      })
    }
  }
}
</script>

<style lang="scss">
.my-bullet {
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background-color: #c5dbec;
  cursor: pointer;
  transition: all 1s;
  &:not(:last-child) {
    margin-right: 8px;
  }
}

.my-bullet-active {
  overflow: hidden;
  width: 18px;
  background: #eb543c;
  border-radius: 3px;
}
</style>
<style lang="scss" scoped>
.m-base-swiper {
  position: relative;
}
.swiper-container {
  height: 195px;
  width: 100%;
  overflow: hidden;
  .swiper-content {
    display: flex;
    height: 100%;
    width: 100%;
    .swiper-item {
      flex-direction: column;
      justify-content: center;
      height: 100%;
      .desc-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 15px;
        .desc-title {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 22px;
          user-select: none;
        }
        .sign {
          width: 20px;
          height: 4px;
          margin: 5px 0px 12px;
          background-color: #eb543c;
        }
        .desc-text {
          padding: 0px 20px;
          font-size: 11px;
          max-width: 820px;
          color: #63676a;
          line-height: 15px;
          user-select: none;
        }
      }
      .banner-image {
        width: 240px;
        height: auto;
        user-select: none;
      }
      .show-image {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .banner-all-image {
          width: auto;
          height: 100%;
          user-select: none;
        }
        .text-wrap {
          position: absolute;
        }
      }
    }
  }
}

// 自定义小圆点
.custom-point {
  display: flex;
  margin: 15px auto 0px;
  width: 95px;
  height: 7px;
  z-index: 6;
}
</style>
